export class Course {
    id: string;
    name: string;
    shortName: string;
    address: string;
    city: string;
    state: string;
    zipCode: string;
    country: string;
    isPrivate: boolean;
}
